import React from 'react';
import SearchSection from '../components/SearchSection';
import MainContent from '../components/MainContent';

const HomePage = () => {
  return (
    <>
      <SearchSection />
      <MainContent />
    </>
  );
};

export default HomePage;
